import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import Reveal from './common/Reveal';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-primary text-primary-foreground mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <Reveal className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-xl font-bold mb-4">Priiyanka's Nature Nest</h3>
            <p className="text-sm text-primary-foreground/80 italic">"Where Nature Nurtures You"</p>
            <p className="text-sm text-primary-foreground/80 mt-4">
              VD. Priyanka Singh<br />
              B.A.M.S Ayurvedic Consultant
            </p>
            <div className="mt-6 flex flex-wrap gap-3 items-center">
              <div className="bg-white p-2 rounded">
                <img
                  src="/assets/certifications/lvnt.jpg"
                  alt="LVNT (Landelijke Vereniging Natuurgeneeskundig Therapeuten) member logo"
                  width="640"
                  height="333"
                  loading="lazy"
                  decoding="async"
                  className="h-12 w-auto object-contain"
                />
              </div>
              <div className="bg-white p-2 rounded">
                <img
                  src="/assets/certifications/rbcz.jpg"
                  alt="RBCZ (Register Beroepsbeoefenaren Complementaire Zorg) registered logo"
                  width="225"
                  height="225"
                  loading="lazy"
                  decoding="async"
                  className="h-12 w-auto object-contain"
                />
              </div>
              <div className="bg-white p-2 rounded">
                <img
                  src="/assets/certifications/tcz.jpg"
                  alt="TCZ registered logo"
                  width="737"
                  height="536"
                  loading="lazy"
                  decoding="async"
                  className="h-12 w-auto object-contain"
                />
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2 text-sm">
              <Link to="/about" className="block hover:text-accent transition-colors">{t('footer.about')}</Link>
              <Link to="/services" className="block hover:text-accent transition-colors">{t('footer.services')}</Link>
              <Link to="/contact" className="block hover:text-accent transition-colors">{t('footer.contact')}</Link>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Legal & Compliance</h4>
            <div className="space-y-2 text-sm">
              <Link to="/privacy" className="block hover:text-accent transition-colors">{t('footer.privacy')}</Link>
              <Link to="/terms" className="block hover:text-accent transition-colors">{t('footer.terms')}</Link>
              <Link to="/suggestions" className="block hover:text-accent transition-colors">{t('footer.suggestions')}</Link>
              <p className="text-primary-foreground/80 mt-4">KVK: 98872109</p>
              <p className="text-primary-foreground/80">VAT: NL005359083B24</p>
              <p className="text-primary-foreground/80 mt-2">LVNT: 26.005</p>
              <p className="text-primary-foreground/80">RBCZ: 260022S</p>
              <p className="text-primary-foreground/80">TCZ Registered</p>
              <p className="text-primary-foreground/80">AGB Healthcare Provider: 90121714</p>
              <p className="text-primary-foreground/80">AGB Praktijk Code: 90096729</p>
              <p className="text-primary-foreground/80">Prestatie code: 24014</p>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <p>The Hague Natural Health Centre<br />Badhuisstraat 224, 2584 HN</p>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <p>Frans Mortelmansstraat 68<br />2273 LE Voorburg, Netherlands</p>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <a href="tel:+31623955935" className="hover:text-accent">+31 623955935</a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:priiyankasnaturenest@gmail.com" className="hover:text-accent">priiyankasnaturenest@gmail.com</a>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="border-t border-primary-foreground/20 mt-12 pt-8 text-center text-sm text-primary-foreground/80">
          <p>© {new Date().getFullYear()} Priiyanka's Nature Nest. {t('footer.rights')}.</p>
          <p className="mt-2">Compliant with LVNT (Landelijke Vereniging Natuurgeneeskundig Therapeuten) regulations.</p>
          <p className="mt-1">Subject to RBCZ (Register Beroepsbeoefenaren Complementaire Zorg) standards.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;